// src/analytics/RetentionCard.jsx
import React from 'react';
import styled from 'styled-components';

const Card = styled.div`
  background: #FFFAF5;
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
`;

const Title = styled.h2`
  color: #FF7C24;
  font-size: 20px;
  margin-bottom: 1rem;
`;

const StatText = styled.p`
  font-size: 16px;
  color: #232830;
  margin-top: 0.5rem;
`;

export default function RetentionCard({ loginAuditData = [] }) {
  return (
    <Card>
      <Title>Retention</Title>
      <StatText>Total Login Events: {loginAuditData.length}</StatText>
    </Card>
  );
}
